export enum RoundState {
  Stopped = "Stopped",
  Breathing = "Breathing",
  BreathHold = "BreathHold",
  Recovery = "Recovery",
}
